/* eslint no-param-reassign: "error" */
import React, {
  useEffect,
  useCallback,
} from 'react';
import {
  Calendar,
} from 'react-big-calendar';

import {
  DateTime,
} from 'luxon';

import {
  shallowEqual,
  useDispatch,
  useSelector,
} from 'react-redux';

import {
  coreActions,
} from '@gymcloud/core';

import {
  history,
} from 'web-history';

import {
  Flex,
  TextOverflowDots,
} from 'web-styled';

import {
  uiActions,
} from 'web-actions';

import {
  getEventsForBigCalendar,
} from 'web-selectors';

import LuxonLocalizer from 'web-components/Calendar/luxonLocalizer';
import Toolbar from './Toolbar';

import * as S from './styled';

type Props = {
  clientInfo: any,
};

type getComponentProps = {
  event: any,
};

const getComponents = () => ({
  toolbar: props => (
    <Toolbar
      {...props}
    />
  ),
  event: ({ event }: getComponentProps) => (
    <Flex
      noScroll
    >
      <TextOverflowDots
        weight={500}
        color="#fff"
        size="11px"
        lineHeight="11px"
      >
        {`${event.startTime} ${event.title}`}
      </TextOverflowDots>
    </Flex>
  ),
});

const CalendarTab = ({ clientInfo }: Props) => {
  const clientId = clientInfo.id;

  const mapState = useCallback(state => ({
    events: getEventsForBigCalendar(clientId)(state),
  }), [clientId]);

  const { events } = useSelector(mapState, shallowEqual);

  const dispatch = useDispatch();

  const fetchEvents = ({ from, to }) => {
    dispatch(coreActions.requestLoadWorkoutEvents({
      params: {
        range_from: from,
        range_to: to,
      },
      userId: clientId,
    }));
  };

  useEffect(() => {
    fetchEvents({
      from: DateTime.utc().startOf('month'),
      to: DateTime.utc().endOf('month'),
    });
    dispatch(coreActions.requestLoadPersonalWorkouts({
      userId: clientId,
    }));
  }, []);

  return (
    <S.CalendarContainer>
      <Calendar
        style={{
          width: '100%',
        }}
        views={['month']}
        popup
        selectable
        events={events}
        onSelectEvent={(event) => {
          history.push(`/events/${event.id}/results`);
        }}
        onSelectSlot={({ start }) => {
          dispatch(uiActions.setUiState({ currentCalendarDate: new Date(start) }));
        }}
        components={getComponents()}
        localizer={LuxonLocalizer(DateTime, { firstDayOfWeek: 0 })}
        startAccessor="start"
        endAccessor="end"
        onNavigate={(day) => {
          fetchEvents({
            from: DateTime.fromJSDate(day).toUTC().startOf('month'),
            to: DateTime.fromJSDate(day).toUTC().endOf('month'),
          });
        }}
      />
    </S.CalendarContainer>
  );
};

export default CalendarTab;
